<template>
  <v-row>
    <v-col class="d-block pt-0" cols="12">
      <v-alert v-for="(ticketBanner, i) in ticketBanners"
               type="warning"
               color="red lighten-1"
               class="py-3 px-1 mb-3"
               :key="`tb-${i}`">
        <template v-slot:prepend>
          <v-icon class="mx-2 d-none d-sm-block white--text">mdi-alert-circle-outline</v-icon>
        </template>
        <div class="hidden-xs-only white--text">
          <div class="d-flex justify-space-between align-center">
            <div>
              <p class="font-weight-bold mb-0">{{ ticketBanner.title }} | {{ ticketBanner.ticket_mask_id }}</p>
              <p class="mb-0">{{ ticketBanner.message }}</p>
            </div>
            <gg-btn dark
                    color="red"
                    tile
                    class="flex-shrink mr-2"
                    :to="{ name: 'ticket_view', params: { ticketid: ticketBanner.ticket_mask_id } }">
              View Ticket
            </gg-btn>
          </div>
        </div>
        <div class="hidden-sm-and-up white--text">
          <div>
            <p class="font-weight-bold">{{ ticketBanner.title }}</p>
            <p>{{ ticketBanner.message }}</p>
          </div>
          <router-link :to="{ name: 'cancellations', params: { ticketid: ticketBanner.ticket_mask_id } }"
                       class="white--text fw-bold underline">
            View Ticket
          </router-link>
        </div>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TicketAlerts',
  computed: {
    ...mapGetters(['ticketBanners'])
  }
}
</script>
